import React, { useEffect, useState } from "react";
import "../../assets/css/Post.css";
import RightNavigation from "../../Views/Navigation/RightNavigation";
// import { NewsFeed, post } from "../../assets/Images/ImagesLink";
import PostInteractionModal from "../NewsFeed/PostInteractionModal";
import axios from "../../API/axios";
import { Link, NavLink, useParams } from "react-router-dom";
import { ShimmerThumbnail } from "react-shimmer-effects";
import moment from "moment/moment";
import PostEngagement from "../NewsFeed/PostEngagement";
import ImageSliderModal from "../NewsFeed/ImageSliderModal";
import { ShimmerDiv } from "shimmer-effects-react";
import SinglePostEngagement from "../NewsFeed/SinglePostEngagement";
import SinglePostInteraction from "../NewsFeed/SinglePostInteraction";
import SinglePostComment from "../NewsFeed/SinglePostComment";
import LikesDetails from "../NewsFeed/LikesDetails";
import { Helmet } from "react-helmet";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Tag } from "antd";

const ArticleDetail = () => {
  const guestModeData = localStorage.getItem("guestMode");
  const sessionId = localStorage.getItem("sessionId");

  const [article, setArticle] = useState();
  const { slug } = useParams();
  const [isError, setIsError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [dLike, setDLike] = useState(0);
  const [singlepostId, setSinglePostId] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [postList, setPostList] = useState([]);

  //Fetching article detail
  useEffect(() => {
    if (!slug) return;

    const fetchArticle = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(
          `/Posts/GetArticleInfo?DeviceType=Web&TitleSlug=${slug}`
        );
        console.log("articleDetailResp", res.data.responseData);
        setArticle(res.data.responseData);
      } catch (error) {
        console.error("Error fetching article:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchArticle();
  }, [slug]);

  const openModal = (images) => {
    setModalImages(images);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [singlePostContent, setSinglePostContent] = useState("");
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);

  const updateLikeCount = (postId, delta) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, likeCount: post.likeCount + delta }
          : post
      )
    );
  };

  const updateCommentCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, commentCount: post.commentCount + change }
          : post
      )
    );
  };

  const updateShareCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, shareCount: post.shareCount + change }
          : post
      )
    );
  };

  const [postLikedType, setPostLikedType] = useState(false);

  const handleShowModal = (item) => {
    // setPostId(item.postId);
    setPostLikedType(item.likedType);
    setShowModal(true);
  };

  const handleLikesCloseModal = () => {
    setShowModal(false);
    // setSelect
    // edItem(null);
  };

  const postId = article?.postInfo?.postId;

  const [singlepostList, setSinglePostList] = useState([]);
  const AllPostList = async () => {
    const Data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    try {
      await axios
        .get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}`)
        .then((resData) => {
          setIsLoading(false);
          console.log("resData", resData);
          if (resData.status === 204) {
            setIsError(true);
          } else {
            setSinglePostList(resData.data.responseData);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    AllPostList();
  }, [postId]);

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };
  console.log("singlepostList", singlepostList);

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${item.entityID}" class="user-mention">@${item.displayName}</a>`
          : item.type === "Hashtag"
          ? `<a href="/hashtag/${item.entityID}" class="hashtag">#${item.displayName}</a>`
          : item.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

  const formattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        singlepostList?.postInfo?.postContent,
        singlepostList?.postInfo?.dynamicValues
      )
    )
  );

  const [openBgModal, setOpenBgModal] = useState(false);
  const handleOpen = () => {
    setOpenBgModal(true);
  };

  const handleOpenBgCloseModal = () => {
    setOpenBgModal(false);
  };

  useEffect(() => {
    if (openBgModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [openBgModal]);

  return (
    <div>
      <Helmet>
        <title> {`${article?.postInfo?.userName} `} || Welinkjobs</title>
        <meta name="description" content="How to create an effective resume" />
        <meta name="keywords" content="newsfeed, updates, latest news" />
        <meta property="og:title" content="John Doe Profile | Welinkjobs" />
        <meta
          property="og:description"
          content="How to create an effective resume"
        />
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113"
        ></script>
      </Helmet>
      {isError ? (
        <div className="d-flex justify-content-center align-items-center">
          <img src="/images/error-small.png" alt="404 Not Found" width={200} />
        </div>
      ) : (
        <div className="row w-100 m-0 singlePostLink ">
          <div className="col-md-8 p-md-0 p-2">
            <div className="Profilebackground mt-2">
              <div className="background-overlay" onClick={() => handleOpen()}>
                <img
                  src={
                    article?.postInfo?.mediaFilesList?.[0]?.mediaName ||
                    "fallback-image-url.jpg"
                  }
                  alt="Background"
                />
              </div>
            </div>
            <h2 className="fw-bold pt-4">{article?.postInfo?.title}</h2>

            <div className="">
              {article?.tags?.length > 0
                ? article.tags.map((tag, index) => (
                    <Tag key={index} color="blue">
                      {tag}
                    </Tag>
                  ))
                : ""}
            </div>

            <div
              className="article-content py-md-4"
              dangerouslySetInnerHTML={{
                __html: article?.postInfo?.postContent,
              }}
            ></div>
          </div>

          <div
            className="col-md-4 p-0"
            style={{
              overflowY: "auto",
              maxHeight: "90vh",
              position: "sticky",
              top: "70px",
            }}
          >
            <div className="featured-card user-postOnlyContent p-2 m-2">
              <div className="feature-content p-2 d-flex justify-content-between">
                <Link to="/Company/123456">
                  <div className="d-flex align-items-center">
                    <div className="ImgAvatar">
                      <img
                        src={article?.postInfo?.userAvatar}
                        alt="Article Publisher Profile Image"
                        style={{ borderRadius: "50px" }}
                      />
                    </div>
                    <div className="ms-2">
                      <h4 className="f-14 fw-bold mb-0">
                        {article?.postInfo?.userName}
                      </h4>
                      <p className="f-12">
                        {moment
                          .utc(article?.postInfo?.creationTime)
                          .local()
                          .format("DD MMMM YYYY [at] h:mm a")}
                      </p>
                    </div>
                  </div>
                </Link>

                <div className="row">
                  <div>
                    <SinglePostInteraction
                      postId={article?.postInfo?.postId}
                      AllPostList={AllPostList}
                      singlepostList={singlepostList?.postInfo}
                      setSinglePostList={setSinglePostList}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="f-14 p-2 postContent">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      "Looking for experienced software developers to join our growing team! We offer competitive benefits and remote work options. <a href='https://example.com/jobs'>Click here</a> to learn more about the position and apply.",
                  }}
                />
              </div> */}

              <div className="feed-post p-2">
                {guestModeData === "true" ? null : (
                  <div className="row">
                    <div className="addComment">
                      <SinglePostComment
                        postId={article?.postInfo?.postId}
                        AllPostList={AllPostList}
                        singlepostList={singlepostList?.postInfo}
                        setSinglePostList={setSinglePostList}
                        ispostmodalOpen={ispostmodalOpen}
                        setIspostmodalOpen={setIspostmodalOpen}
                        setPostList={setPostList}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`postData d-flex align-items-center ${
                  article?.postInfo?.likeCount === 0 &&
                  article?.postInfo?.commentCount === 0 &&
                  article?.postInfo?.shareCount === 0
                    ? ""
                    : "border-custom1"
                }`}
              >
                <div className="ms-2">
                  {article?.postInfo?.likeCount === 0 ? (
                    ""
                  ) : (
                    <p
                      className="f-10 like-details"
                      onClick={() => handleShowModal(article?.postInfo)}
                    >
                      {article?.postInfo?.likeCount + dLike} likes
                    </p>
                  )}
                </div>
                <div className="ms-auto d-flex">
                  {article?.postInfo?.commentCount === 0 ? (
                    ""
                  ) : (
                    <p className="f-10 me-2 pointer">
                      {article?.postInfo?.commentCount} comments{" "}
                    </p>
                  )}

                  <p className="f-10">
                    {article?.postInfo?.shareCount === 0
                      ? ""
                      : `&  ${article?.postInfo?.shareCount} Shares`}
                  </p>
                </div>
              </div>

              <div className="postengagement">
                <SinglePostEngagement
                  postId={article?.postInfo?.postId}
                  AllPostList={AllPostList}
                  singlepostList={singlepostList}
                  setSinglePostList={setSinglePostList}
                  ispostmodalOpen={ispostmodalOpen}
                  setIspostmodalOpen={setIspostmodalOpen}
                  openModal={openModal}
                  setSinglePostId={setSinglePostId}
                  setSinglePostContent={setSinglePostContent}
                  setDLike={setDLike}
                  updateLikeCount={updateLikeCount}
                />
                <LikesDetails
                  showModal={showModal}
                  handleLikesCloseModal={handleLikesCloseModal}
                  postId={article?.postIndo?.postId}
                  postLikedType={postLikedType}
                  setShowModal={setShowModal}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {openBgModal && (
        <div
          className="modal fade show postAdd modal-lg"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
          size="lg"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Company Background View</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => handleOpenBgCloseModal()}
                />
              </div>
              <div className="p-2">
                <div className="backrgound-profile-view d-flex justify-content-center">
                  <img
                    src={article?.postInfo?.mediaFilesList?.[0]?.mediaName}
                    alt="Background"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleDetail;
